import { useEffect, useRef } from 'react'

/**
 * Fire `callback` exactly once each time `value` transitions from
 * falsy → truthy. Useful for "modal-opened" analytics events that
 * shouldn't fire on remount, on initial-undefined hydration, or on
 * every subsequent render while the modal stays open.
 *
 * The latest `callback` is captured in a ref so changing it between
 * renders doesn't re-fire and doesn't require memoizing it at the
 * call site.
 */
export function useOnTransitionToTrue(value: unknown, callback: () => void) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  const prevRef = useRef(false)
  useEffect(() => {
    const next = !!value
    if (next && !prevRef.current) {
      callbackRef.current()
    }
    prevRef.current = next
  }, [value])
}
